import Commands from './commands';

class Push extends Commands {
    constructor(registry) {
        super("push", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);
        const value = this.registry.get(key) || [];
        if (!Array.isArray(value)) {
            throw "Invalid Assignment of array";
        }

        for (let index = 1; index < node.params.length; index++) {
            value.push(await emitter(node.params[index], options));
        }

        this.registry.set(key, value);
        return value;
    }
}

export default Push;
